// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2qY7E","wrapper":"App_wrapper__38CLC","subwrapper":"App_subwrapper__V-Mbi","right":"App_right__3cJl8"};